import { t } from "i18next";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { estimateDetailsGetByIdAPI } from "../../../api/url";
import { EListCardView, EParentModuleName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import EstimateDetailsView from "./EstimateDetailView";
export default function EstimateDetailsIndex() {
    var navigate = useNavigate();
    var _a = useState(false), openPopup = _a[0], setOpenPopup = _a[1];
    var isDocDataUpdated = useSelector(function (state) { return state.common; }).isDocDataUpdated;
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var state = useLocation().state;
    var documentId = useParams().documentId;
    var handleHeaderBackClick = function (status) {
        if (isDocDataUpdated) {
            setOpenPopup(true);
        }
        else {
            if (state !== null && state !== void 0 && state.fromRoute) {
                navigate(state === null || state === void 0 ? void 0 : state.fromRoute);
                return;
            }
            if ((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) === "ServiceAdvisor") {
                if (status === EListCardView.ServiceEstimateCreated || status === EListCardView.ServiceEstimateError) {
                    navigate("/serviceEstimate-tasksDetails/".concat(documentId));
                    return;
                }
            }
            navigate(-1);
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EstimateDetailsView, {
        getDocumentByIDURL: estimateDetailsGetByIdAPI,
        headerTitle: t("JOB_CARD_DETAILS"),
        headerBackClick: handleHeaderBackClick,
        parentDocument: EParentModuleName.DetailServiceEstimate,
        createAndEditFlow: {
            isEstimate: "Update"
        }
    }));
}
